import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { SignUpFormComponent } from './sign-up-form.component';

const SHOWCASE_HIDDEN_QUERY = '(max-width: 1100px)';

@Component({
  selector: 'app-sign-up-form-v2',
  styleUrls: ['./sign-up-form-v2.component.scss'],
  templateUrl: './sign-up-form-v2.component.html',
  host: { '[class.full-width]': 'fullWidth' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SignUpFormV2Component extends SignUpFormComponent {
  readonly showcaseVisible$ = inject(BreakpointObserver)
    .observe(SHOWCASE_HIDDEN_QUERY)
    .pipe(map((state) => !state.matches));
}
